import { render } from "./CreateBrand.vue?vue&type=template&id=2aff37f2"
import script from "./CreateBrand.vue?vue&type=script&lang=js"
export * from "./CreateBrand.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/vhosts/localhost/storage/app/public/maskansazangolchin-site/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__